<div class="host ___dashboard page">

  <h1>Dashboard</h1>

  <section class="welcome card">
    <div class="card-body">
      <h2>Welcome to Dashboard!</h2>
      <p class="subtitle">Manage your web app content in one place.</p>
    </div>
  </section>
  
  <!-- <section class="widgets">

    <div class="news card">
      <div class="card-head"><h4>Events and News</h4></div>
      <div class="card-body">
        <p>Lorem ipsum.</p>
        <ul>
          <li><a href="#">Link 1</a></li>
          <li><a href="#">Link 2</a></li>
          <li><a href="#">Link 3</a></li>
        </ul>
      </div>
      <div class="card-foot">
        <a href="#">Mola</a>
        <a href="#">Lam Nhan</a>
      </div>
    </div>

  </section> -->

</div>